export default "__VITE_ASSET__D3x9TfZi__"